import { render } from "./FinalPageContentSection.vue?vue&type=template&id=84fbca7a&scoped=true"
import script from "./FinalPageContentSection.vue?vue&type=script&lang=js"
export * from "./FinalPageContentSection.vue?vue&type=script&lang=js"

import "./FinalPageContentSection.vue?vue&type=style&index=0&id=84fbca7a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84fbca7a"]])

export default __exports__